import { assetUrl } from '../config/asset-config';

(function () {
    'use strict';

    angular.module('thankview.recordingsPreview', [])
        .directive('overlayRecordingsPreview', ['$rootScope', 'ajax', '$timeout', '$q', '$interval', '$window', function ($rootScope, ajax, $timeout, $q, $interval, $window) {
            return {
                restrict: 'E',
                scope: true,
                templateUrl: '/templates/recordings-preview/overlay-recordings-preview.html?v=' + config.version,
                link: function (scope, element) {
                    var hasPlayedSequence = false;
                    var fadeIn = 0.75; // fade time from intro to video 1.
                    var fadeOut = 0.05; // fade time from the last recorded video to the outro.
                    var shortCut = 0.1; // cut time if video_type is 'upload'.
                    var longCut = 0.5; // cut time if video_type is not 'upload'.

                    // Defining function variables
                    var buildTimeObj;
                    var calculateTotalTime;
                    var clickSetTime;
                    var getDisplayTime;
                    var moveSliderByTime;
                    var setupScrollBar;
                    var videoSliderClick;
                    var interval;

                    scope.players = {
                        intro: { id: 'recordings-preview-intro', vidJSPlayer: null },
                        video1: { id: 'recordings-preview-video1', vidJSPlayer: null },
                        video2: { id: 'recordings-preview-video2', vidJSPlayer: null },
                        end: { id: 'recordings-preview-end', vidJSPlayer: null },
                    };

                    scope.stopInterval = function () {
                        if (angular.isDefined(interval)) {
                            $interval.cancel(interval);
                            interval = undefined;
                        }
                    };

                    scope.$on('$destroy', function () {
                        // Make sure that the interval is destroyed too
                        scope.stopInterval();
                    });

                    scope.$on('open-overlay-recordings-preview', function ($event, video, overlay) {
                        $rootScope.$broadcast('open-loading');
                        scope.initOverlay();

                        scope.fetchProject($rootScope.currentProject.id);

                        if (!video) {
                            scope.fetchVideos();
                        } else {
                            scope.videos = [video];
                            scope.video1 = scope.videos[scope.videoIndex];
                        }

                        if (overlay) {
                            scope.videoOverlay = overlay;
                        } else {
                            scope.videoOverlay = null;
                        }
                    });

                    scope.$on('close-overlay', function () {
                        console.log('closing overlay');
                        scope.stopInterval();
                        if (scope.videoSlider) {
                            scope.videoSlider.removeEventListener('click', videoSliderClick);
                        }
                        angular.forEach(scope.players, function (player) {
                            if (player.vidJSPlayer) {
                                player.vidJSPlayer.pause();
                                player.vidJSPlayer.dispose();
                            }
                            player.vidJSPlayer = null;
                        });
                    });

                    scope.initOverlay = function () {
                        scope.currentPlayer = null;
                        scope.project = null;
                        scope.videos = null;
                        scope.video1 = null;
                        scope.video2 = null;
                        scope.videoIndex = 0;
                        scope.videoTimeOffset = 0;
                    };

                    scope.fetchProject = function (id) {
                        ajax.get('/api/project', { project_id: id || '' }).then(function (data) {
                            if (!data.canProcess) {
                                $rootScope.$broadcast('open-message', 'Your intro is missing an image. Please complete your intro before previewing.', { width: 600 });
                            } else if (!data.project.processing && (data.project.theme_id || data.project.preview_path)) {
                                scope.project = data.project;

                                if (!scope.project.theme_id) {
                                    scope.project.theme_id = scope.project.intro ? scope.project.intro.theme_id : '';
                                }

                                if (data.overlay && !scope.videoOverlay) {
                                    scope.videoOverlay = data.overlay;
                                }

                                if (scope.project.no_end_card) {
                                    fadeOut = 0;
                                }

                                if (scope.videos) scope.initVideos();
                            } else {
                                $rootScope.$broadcast('open-message', 'The videos in your campaign are still processing. Please try again in 30 seconds.', { width: 600 });
                            }
                        });
                    };

                    scope.fetchVideos = function () {
                        ajax.get('/api/project/uniqueVideos').then(function (data) {
                            scope.videos = data.videos;
                            scope.video1 = scope.videos[scope.videoIndex];
                            if (scope.project) scope.initVideos();
                        });
                    };

                    scope.fetchVideo2 = function () {
                        var deferred = $q.defer();

                        ajax.get('/api/library/' + scope.project.library_video_id).then(function (data) {
                            scope.video2 = data.video;

                            scope.loadVideo2(deferred);
                        });

                        return deferred.promise;
                    };

                    scope.initVideos = function () {
                        if (!scope.videos.length && !scope.project.theme_id) {
                            const params = {
                                header: 'No intro/video added',
                            };
                            $rootScope.$broadcast('open-message', 'Please add an intro or video to preview the video sequence.', params);
                            return;
                        }

                        var videoPromises = [];

                        if (scope.project.theme_id) {
                            videoPromises.push(scope.loadIntro());
                        }

                        if (scope.videos.length) {
                            videoPromises.push(scope.loadVideo1());
                        }

                        if (scope.project.library_video_id) {
                            videoPromises.push(scope.fetchVideo2());
                        }

                        if (!scope.project.no_end_card) {
                            videoPromises.push(scope.loadEndCard());
                        }

                        // wait till all videos are loaded before showing overlay
                        $q.all(videoPromises).then(function () {
                            scope.setVideoReady();

                            scope.$broadcast('open-overlay');

                            $timeout(function () {
                                $rootScope.$broadcast('close-loading');
                            });
                            return calculateTotalTime();
                        }).then(function (res) {
                            scope.timeObj = res;
                            setupScrollBar(true);
                        });
                    };

                    scope.loadIntro = function () {
                        var deferred = $q.defer();

                        var videoUrl = $rootScope.assetUrlRoot + '/' + scope.project.preview_path;

                        scope.players.intro.vidJSPlayer = scope.loadVideo(scope.players.intro.id, videoUrl, scope.project.preview_path_thumb, null);
                        scope.players.intro.vidJSPlayer.on('ready', function () {
                            deferred.resolve();
                        });

                        scope.players.intro.vidJSPlayer.on('playing', function () {
                            scope.playing = true;
                        });

                        scope.players.intro.vidJSPlayer.on('timeupdate', function () {
                            var time = {
                                position: scope.players.intro.vidJSPlayer.currentTime(),
                                duration: scope.players.intro.vidJSPlayer.duration(),
                            };
                            if (scope.currentPlayer !== scope.players.intro) return;

                            if (scope.players.video1.vidJSPlayer) {
                                if (time.duration - time.position <= fadeIn) {
                                    scope.videoTimeOffset = scope.timeObj.intro - fadeIn;
                                    scope.playVideo1();
                                    scope.$apply();
                                }
                            } else if (time.duration - time.position <= fadeIn) {
                                if (scope.players.end.vidJSPlayer) {
                                    scope.videoTimeOffset += (scope.timeObj.intro - fadeIn);
                                    scope.playEnd();
                                    scope.$apply();
                                } else {
                                    scope.restartPlayer();
                                }
                            }
                        });

                        scope.players.intro.vidJSPlayer.on('click', scope.togglePlaying);

                        return deferred.promise;
                    };

                    scope.loadVideo1 = function () {
                        var deferred = $q.defer();

                        var video = scope.videos[scope.videoIndex];

                        scope.players.video1.vidJSPlayer = scope.loadVideo(scope.players.video1.id, video.video_path, video.video_thumb, video.caption_url, video.autoplay_captions);

                        scope.players.video1.vidJSPlayer.on('ready', function () {
                            $rootScope.$broadcast('player-ready');
                            deferred.resolve();
                        });

                        scope.players.video1.vidJSPlayer.on('playing', function () {
                            scope.playing = true;
                        });

                        scope.players.video1.vidJSPlayer.on('timeupdate', function () {
                            var time = {
                                position: scope.players.video1.vidJSPlayer.currentTime(),
                                duration: scope.players.video1.vidJSPlayer.duration(),
                            };
                            // Use end trim as the video duration if it exists
                            var videoDuration = video.end_trim ? video.end_trim : time.duration;

                            if (scope.currentPlayer !== scope.players.video1) return;

                            if (scope.players.video2.vidJSPlayer) {
                                var cutoffTime = video.video_type === 'upload' ? shortCut : longCut;

                                if (videoDuration - time.position <= cutoffTime) {
                                    scope.players.video1.vidJSPlayer.pause();
                                    scope.videoTimeOffset += (scope.timeObj.video1 - cutoffTime);
                                    scope.playVideo2();
                                    scope.$apply();
                                }
                            } else if (videoDuration - time.position <= fadeOut) {
                                if (scope.players.end.vidJSPlayer) {
                                    scope.videoTimeOffset += (scope.timeObj.video1 - fadeOut);
                                    scope.playEnd();
                                    scope.$apply();
                                } else {
                                    scope.restartPlayer();
                                }
                            }
                        });

                        scope.players.video1.vidJSPlayer.on('click', scope.togglePlaying);

                        return deferred.promise;
                    };

                    scope.loadVideo2 = function (deferred) {
                        scope.players.video2.vidJSPlayer = scope.loadVideo(scope.players.video2.id, scope.video2.video_path, null, scope.video2.caption_url, scope.video2.autoplay_captions);

                        scope.players.video2.vidJSPlayer.on('ready', function () {
                            $rootScope.$broadcast('player-ready');
                            deferred.resolve();
                        });

                        scope.players.video2.vidJSPlayer.on('playing', function () {
                            scope.playing = true;
                        });

                        scope.players.video2.vidJSPlayer.on('timeupdate', function () {
                            var time = {
                                position: scope.players.video2.vidJSPlayer.currentTime(),
                                duration: scope.players.video2.vidJSPlayer.duration(),
                            };
                            // Use end trim as the video duration if it exists
                            var videoDuration = scope.video2.end_trim ? scope.video2.end_trim : time.duration;

                            if (scope.currentPlayer !== scope.players.video2) return;

                            if (videoDuration - time.position <= fadeOut) {
                                if (scope.players.end.vidJSPlayer) {
                                    scope.videoTimeOffset += (scope.timeObj.video2 - fadeOut);
                                    scope.playEnd();
                                    scope.$apply();
                                } else {
                                    scope.restartPlayer();
                                }
                            }
                        });

                        scope.players.video2.vidJSPlayer.on('click', scope.togglePlaying);
                    };

                    var initEndCard = function (videoUrl, deferred) {
                        scope.players.end.vidJSPlayer = scope.loadVideo(scope.players.end.id, videoUrl, null, null, 0);

                        scope.players.end.vidJSPlayer.on('ready', function () {
                            deferred.resolve();
                        });

                        scope.players.end.vidJSPlayer.on('playing', function () {
                            scope.playing = true;
                        });

                        scope.players.end.vidJSPlayer.on('ended', function () {
                            scope.restartPlayer();
                        });

                        scope.players.end.vidJSPlayer.on('click', scope.togglePlaying);
                    };

                    scope.loadEndCard = function () {
                        var deferred = $q.defer();
                        var outroId;
                        if (scope.project.outro_id) {
                            outroId = scope.project.outro_id;
                        } else if (scope.business.default_outro_id) {
                            outroId = scope.business.default_outro_id;
                        }
                        if (outroId) {
                            ajax.get('/api/outro/' + outroId).then(function (data) {
                                var videoUrl = data.outro;
                                initEndCard(videoUrl, deferred);
                            });
                        } else {
                            var videoUrl = $rootScope.assetUrlRoot + '/endcards/default-2020.mp4';
                            initEndCard(videoUrl, deferred);
                        }
                        return deferred.promise;
                    };

                    scope.restartPlayer = function () {
                        scope.stopInterval();
                        scope.playing = false;
                        scope.videoMark.style.left = '0%';
                        scope.timeObj.displayCurrent = '0:00';
                        scope.currentDisplayTime = '0:00';
                        scope.setVideoReady();
                        scope.$apply();
                    };

                    scope.loadVideo = function (videoId, videoUrl, posterImage, captionUrl, autoplayCaptions) {
                        var vidElement = element[0].querySelector('#' + videoId + '-wrapper');

                        var options = {
                            controls: false,
                            autoplay: false,
                            preload: 'auto',
                            aspectRatio: '4:3',
                            muted: false,
                            poster: posterImage || assetUrl('assets/img/white.jpg'),
                        };

                        var appendString = '<video id="' + videoId + '" class="video-js tv-video-player" playsinline> <source src="' + videoUrl + '" />';
                        if (captionUrl) {
                            const autoplayCaptionsDefault = autoplayCaptions ? 'default' : '';
                            appendString += ' <track kind="captions" src="' + captionUrl + '" srclang="en" label="English" ' + autoplayCaptionsDefault + '>';
                        }
                        appendString += '</video>';
                        angular.element(vidElement).append(appendString);

                        var video = videojs(videoId, options);
                        video.volume(0.7); // Set volume to 70%;

                        return video;
                    };

                    scope.setVideoReady = function () {
                        scope.videoReady = true;
                        scope.videoTimeOffset = 0;
                        scope.currentPlayer = scope.project.theme_id ? scope.players.intro : scope.players.video1;
                    };

                    scope.playIntro = function (seekTime) {
                        if (!seekTime) { seekTime = 0; }
                        scope.videoReady = false;
                        scope.videoTimeOffset = 0;

                        scope.currentPlayer = scope.players.intro;
                        scope.players.intro.vidJSPlayer.play();
                        scope.players.intro.vidJSPlayer.currentTime(seekTime);
                    };

                    scope.playVideo1 = function (seekTime) {
                        var video = scope.videos[scope.videoIndex];

                        scope.videoReady = false;

                        scope.currentPlayer = scope.players.video1;
                        scope.players.video1.vidJSPlayer.play();

                        seekTime = seekTime || 0;

                        scope.players.video1.vidJSPlayer.currentTime(seekTime + video.start_trim);
                    };

                    scope.playVideo2 = function (seekTime) {
                        scope.videoReady = false;

                        scope.currentPlayer.vidJSPlayer.pause();

                        scope.currentPlayer = scope.players.video2;
                        scope.players.video2.vidJSPlayer.play();

                        seekTime = seekTime || 0;

                        scope.players.video2.vidJSPlayer.currentTime(seekTime + scope.video2.start_trim);
                    };

                    scope.playEnd = function (seekTime) {
                        if (!seekTime) { seekTime = 0; }
                        scope.videoReady = false;

                        // stop current player after the end card fade transition ends
                        var currentPlayer = scope.currentPlayer;

                        $timeout(function () {
                            // double check the user didn't seek to a different part of the video
                            if (scope.currentPlayer === scope.players.end) {
                                var player = currentPlayer.vidJSPlayer;
                                if (player.currentTime() > 0 && !player.paused() && !player.ended()) {
                                    player.pause();
                                }
                            }
                        }, fadeOut * 1000);

                        scope.currentPlayer = scope.players.end;
                        scope.players.end.vidJSPlayer.play();
                        scope.players.end.vidJSPlayer.currentTime(seekTime);
                    };

                    scope.playSequence = function () {
                        scope.playing = true;
                        if (!hasPlayedSequence) {
                            if (scope.players.end.vidJSPlayer) {
                                scope.players.end.vidJSPlayer.play();
                                scope.players.end.vidJSPlayer.pause();
                            }

                            if (scope.players.video2.vidJSPlayer) {
                                scope.players.video2.vidJSPlayer.play();
                                scope.players.video2.vidJSPlayer.pause();
                            }

                            if (scope.videos.length) {
                                scope.players.video1.vidJSPlayer.play();
                                scope.players.video1.vidJSPlayer.pause();
                            }

                            if (scope.project.theme_id) {
                                scope.players.intro.vidJSPlayer.play();
                                scope.players.intro.vidJSPlayer.pause();
                            }

                            hasPlayedSequence = true;
                        }

                        scope.stopInterval();
                        interval = $interval(function () {
                            if (!scope.skipInterval) {
                                moveSliderByTime();
                            } else {
                                scope.skipInterval = false;
                            }
                        }, 1000 / 24); // 24 fps

                        if (scope.project.theme_id) {
                            scope.playIntro();
                        } else {
                            scope.playVideo1();
                        }
                    };

                    scope.pauseSequence = function () {
                        console.log('pausing sequence');
                        scope.stopInterval();
                        angular.forEach(scope.players, function (player) {
                            if (player.vidJSPlayer) {
                                var vidJS = player.vidJSPlayer;
                                if (vidJS.currentTime() > 0 && !vidJS.paused() && !vidJS.ended()) {
                                    vidJS.pause();
                                }
                            }
                        });
                    };

                    scope.scrollLeft = function ($event) {
                        $event.preventDefault();

                        scope.videoIndex = scope.videoIndex <= 0 ? scope.videos.length - 1 : scope.videoIndex - 1;
                        scope.video1 = scope.videos[scope.videoIndex];

                        scope.loadScrolledVideo();
                    };

                    scope.scrollRight = function ($event) {
                        $event.preventDefault();

                        scope.videoIndex = scope.videoIndex >= scope.videos.length - 1 ? 0 : scope.videoIndex + 1;
                        scope.video1 = scope.videos[scope.videoIndex];

                        scope.loadScrolledVideo();
                    };

                    scope.loadScrolledVideo = function () {
                        scope.pauseSequence();

                        scope.videoReady = false;
                        scope.timesLoaded = false;

                        if (scope.players.video1.vidJSPlayer) {
                            scope.players.video1.vidJSPlayer.dispose();
                            scope.players.video1.vidJSPlayer = null;
                        }

                        scope.loadVideo1().then(function () {
                            var vid1 = scope.videos[scope.videoIndex];
                            var duration = vid1.end_trim ? vid1.end_trim : vid1.video_length;
                            if (vid1.start_trim) {
                                duration -= vid1.start_trim;
                            }
                            scope.timeObj.video1 = duration;
                            scope.timeObj = buildTimeObj(scope.timeObj);
                            setupScrollBar();
                            scope.setVideoReady();
                        });
                    };

                    setupScrollBar = function (first) {
                        scope.videoMark = element[0].querySelector('.video-mark');
                        scope.videoSlider = element[0].querySelector('.video-slider');
                        scope.videoMark.style.left = '0%';

                        if (first) {
                            scope.videoSlider.addEventListener('click', videoSliderClick);
                        }

                        scope.timesLoaded = true;
                    };

                    videoSliderClick = function (event) {
                        var offsetX = Math.max(event.offsetX, 0);
                        var percText;
                        var perc;

                        if (event.target.className.indexOf('timeline-dot') >= 0) {
                            percText = event.target.style.left;
                            perc = parseInt(percText.replace('%', ''), 10) / 100;
                        } else if (event.target.className === 'video-slider' || event.target.className === 'video-slider-line') {
                            perc = offsetX / scope.videoSlider.scrollWidth;
                            percText = (perc * 100) + '%';
                        }

                        if (percText) {
                            scope.videoMark.style.left = percText;
                            clickSetTime(perc);
                        }
                    };

                    calculateTotalTime = function (promise) {
                        var q = promise;
                        if (!promise) { q = $q.defer(); }
                        var good = true;
                        var obj = {};

                        angular.forEach(scope.players, function (player, key) {
                            if (player.vidJSPlayer) {
                                var dur = player.vidJSPlayer.duration();
                                if (dur === 0 || $window.isNaN(dur)) {
                                    good = false;
                                } else {
                                    if (key === 'video1') {
                                        if (scope.videos[scope.videoIndex].start_trim && !scope.videos[scope.videoIndex].video_untrimmed) {
                                            dur -= scope.videos[scope.videoIndex].start_trim;
                                        }
                                        if (scope.videos[scope.videoIndex].end_trim && !scope.videos[scope.videoIndex].video_untrimmed) {
                                            dur -= (scope.videos[scope.videoIndex].video_length - scope.videos[scope.videoIndex].end_trim);
                                        }
                                    } else if (key === 'video2') {
                                        if (scope.video2.start_trim && !scope.video2.video_untrimmed) {
                                            dur -= scope.video2.start_trim;
                                        }
                                        if (scope.video2.end_trim && !scope.video2.video_untrimmed) {
                                            dur -= (scope.video2.video_length - scope.video2.end_trim);
                                        }
                                    }
                                    obj[key] = dur;
                                }
                            }
                        });

                        if (good) {
                            q.resolve(buildTimeObj(obj));
                        } else {
                            $timeout(function () {
                                return calculateTotalTime(q);
                            }, 100);
                        }
                        return q.promise;
                    };

                    buildTimeObj = function (obj) {
                        // Subtract for transitions.
                        obj.total = 0;
                        var video = scope.videos[scope.videoIndex];
                        if (obj.intro) {
                            obj.total += obj.intro;
                            if (obj.video1) {
                                obj.total -= fadeIn;
                            }
                        }
                        if (obj.video1) {
                            obj.total += obj.video1;
                        }
                        if (obj.video2) {
                            obj.total += obj.video2;
                            if (video.video_type === 'upload') {
                                obj.total -= shortCut;
                            } else {
                                obj.total -= longCut;
                            }
                        }
                        if (obj.end) {
                            obj.total += (obj.end - fadeOut);
                        }
                        var cutoffTime = 0;
                        var beforeTime = 0;
                        if (obj.intro) {
                            obj.introStart = { left: '0%' };
                        }
                        if (obj.video1) {
                            beforeTime = 0;
                            if (obj.intro) {
                                cutoffTime += fadeIn;
                                beforeTime += (obj.intro - cutoffTime);
                            }
                            obj.vid1Start = { left: ((beforeTime / obj.total) * 100) + '%' };
                        }
                        if (obj.video2) {
                            if (video.video_type === 'upload') {
                                cutoffTime += shortCut;
                            } else {
                                cutoffTime += longCut;
                                obj.captured = true;
                            }
                            beforeTime = 0 - cutoffTime;
                            if (obj.intro) { beforeTime += obj.intro; }
                            if (obj.video1) { beforeTime += obj.video1; }
                            obj.vid2Start = { left: (((beforeTime / obj.total) * 100)) + '%' };
                        }

                        cutoffTime += fadeOut;
                        beforeTime = 0 - cutoffTime;
                        if (obj.intro) { beforeTime += obj.intro; }
                        if (obj.video1) { beforeTime += obj.video1; }
                        if (obj.video2) { beforeTime += obj.video2; }
                        obj.endStart = { left: ((beforeTime / obj.total) * 100) + '%' };

                        obj.displayTotal = getDisplayTime(obj.total);
                        obj.displayCurrent = '0:00';
                        scope.currentDisplayTime = '0:00';

                        return obj;
                    };

                    moveSliderByTime = function () {
                        var vidTime = scope.currentPlayer.vidJSPlayer.currentTime();
                        var video1 = scope.videos[scope.videoIndex];
                        var video2 = scope.video2;
                        if (scope.currentPlayer.id === 'recordings-preview-video1' && video1.start_trim && !video1.video_untrimmed) {
                            vidTime -= video1.start_trim;
                        } else if (scope.currentPlayer.id === 'recordings-preview-video2' && video2.start_trim && !video1.video_untrimmed) {
                            vidTime -= video2.start_trim;
                        }
                        var currentTime = vidTime + scope.videoTimeOffset;

                        if (vidTime > 0) {
                            var dispTime = getDisplayTime(currentTime);
                            scope.timeObj.displayCurrent = dispTime;
                            if (scope.currentDisplayTime !== dispTime) {
                                scope.currentDisplayTime = dispTime;
                            }

                            var perc = currentTime / scope.timeObj.total;
                            var currPerc = scope.videoMark.style.left;
                            var currNum = Number(currPerc.slice(0, currPerc.length - 1));
                            if ((perc * 100) > currNum) {
                                scope.videoMark.style.left = (perc * 100) + '%';
                            }
                        }
                    };

                    clickSetTime = function (perc) {
                        scope.skipInterval = true;
                        scope.playing = true;
                        angular.forEach(scope.players, function (player) {
                            if (player.vidJSPlayer) {
                                var vidJS = player.vidJSPlayer;
                                if (vidJS.currentTime() > 0 && !vidJS.paused() && !vidJS.ended()) {
                                    vidJS.pause();
                                }
                            }
                        });
                        var times = scope.timeObj;
                        if (!times.intro) {
                            times.intro = 0;
                        }
                        var currentTime = times.total * perc;
                        var displayTime = getDisplayTime(currentTime);
                        scope.timeObj.displayCurrent = displayTime;
                        scope.currentDisplayTime = displayTime;

                        if (currentTime >= times.total - times.end - fadeOut) {
                            scope.videoTimeOffset = -1 * fadeOut;
                            if (times.intro) {
                                scope.videoTimeOffset += times.intro - fadeIn;
                            }
                            if (times.video1) {
                                scope.videoTimeOffset += times.video1;
                            }
                            if (times.video2) {
                                scope.videoTimeOffset += times.video2;
                                if (times.captured) {
                                    scope.videoTimeOffset -= longCut;
                                } else {
                                    scope.videoTimeOffset -= shortCut;
                                }
                            }

                            scope.playEnd(currentTime - (times.total - times.end - fadeOut));
                        } else if (currentTime < times.intro - fadeIn) {
                            scope.videoTimeOffset = 0;
                            scope.playIntro(currentTime);
                        } else {
                            var offset = scope.captured ? longCut : shortCut;
                            if (times.video2 && (currentTime > (times.intro + times.video1 - offset - fadeIn))) {
                                scope.videoTimeOffset = times.intro + times.video1 - offset - fadeIn;
                                scope.playVideo2(currentTime - (times.intro + times.video1 - offset - fadeIn));
                            } else {
                                scope.videoTimeOffset = times.intro - fadeIn;
                                scope.playVideo1(currentTime - (times.intro - fadeIn));
                            }
                        }
                    };

                    getDisplayTime = function (time) {
                        var round = Math.round(time);
                        var minutes = Math.floor(round / 60);
                        var seconds = round % 60;
                        if (seconds < 10) {
                            seconds = '0' + seconds;
                        }
                        return minutes + ':' + seconds;
                    };

                    scope.playVideo = function () {
                        scope.playing = true;
                        scope.currentPlayer.vidJSPlayer.play();
                    };

                    scope.pauseVideo = function () {
                        scope.playing = false;
                        scope.currentPlayer.vidJSPlayer.pause();
                    };

                    scope.togglePlaying = function () {
                        if (scope.playing) {
                            scope.pauseVideo();
                        } else {
                            scope.playVideo();
                        }
                    };
                },
            };
        }]);
}());
